import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useContext } from 'react';
import { get, isArray } from 'lodash';
import DSSeparator from '@elliemae/ds-separator';
import { SimpleTruncatedTooltipText } from '@elliemae/ds-truncated-tooltip-text';
import { DropDownContext } from '../context.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isOptionAGroup = function isOptionAGroup(option) {
  return option && option.type && option.type.name === 'Group';
};

var CustomOption = function CustomOption(_ref) {
  var _option$props, _option$props2, _option$props2$innerP, _option$props3, _option$props3$innerP;

  var index = _ref.index,
      data = _ref.data,
      style = _ref.style;
      _ref.isScrolling;
  var items = data.items,
      useTruncatedText = data.options.useTruncatedText;
  var option = items[index];

  var _useContext = useContext(DropDownContext),
      value = _useContext.value;

  var isSelected = (value === null || value === void 0 ? void 0 : value.label) === (option === null || option === void 0 ? void 0 : (_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.label); // react-select performance optimization

  option === null || option === void 0 ? true : (_option$props2 = option.props) === null || _option$props2 === void 0 ? true : (_option$props2$innerP = _option$props2.innerProps) === null || _option$props2$innerP === void 0 ? true : delete _option$props2$innerP.onMouseMove;
  option === null || option === void 0 ? true : (_option$props3 = option.props) === null || _option$props3 === void 0 ? true : (_option$props3$innerP = _option$props3.innerProps) === null || _option$props3$innerP === void 0 ? true : delete _option$props3$innerP.onMouseOver;
  var renderOptionStyle = isOptionAGroup(option) ? {} : style;

  var optionProps = _objectSpread(_objectSpread({}, option.props.innerProps), {}, {
    style: renderOptionStyle,
    'data-testid': 'combobox-option',
    role: 'option',
    'aria-selected': isSelected,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (option.props.innerProps.onClick) option.props.innerProps.onClick(e);
    }
  });

  if (useTruncatedText && get(option, 'props.selectProps.menuIsOpen')) {
    return /*#__PURE__*/React.cloneElement(option, _objectSpread(_objectSpread({}, option.props), {}, {
      innerProps: optionProps,
      tabIndex: 0
    }), /*#__PURE__*/React.createElement(React.Fragment, null, option.props.data.hasSeparator && !isArray(option.props.data.options) && /*#__PURE__*/React.createElement(DSSeparator, {
      margin: "none",
      style: {
        zIndex: -2
      },
      type: "non-form"
    }), /*#__PURE__*/React.createElement(SimpleTruncatedTooltipText, {
      value: option.props.children
    })));
  }

  return /*#__PURE__*/React.cloneElement(option, _objectSpread(_objectSpread({}, option.props), {}, {
    tabIndex: 0,
    innerProps: optionProps
  }), /*#__PURE__*/React.createElement(React.Fragment, null, option.props.data.hasSeparator && !isArray(option.props.data.options) && /*#__PURE__*/React.createElement(DSSeparator, {
    margin: "none",
    style: {
      zIndex: -2
    },
    type: "non-form"
  }), option.props.children));
};

export default CustomOption;
//# sourceMappingURL=CustomOption.js.map
